import AttendAllowanceCreateForm from './AttendAllowanceCreateForm';

export default AttendAllowanceCreateForm;
